/**
 * Created by mukund on 2/27/17.
 */

angular.module('mediacloudApp')
    .directive('lmsSingleUploader', ['FileUploader', 'BaseFileService', 'JobService', 'UploadErrors', 'UploadLimits', function(FileUploader, BaseFileService, JobService, UploadErrors, UploadLimits){

        return {
            restrict: 'E',
            replace: true,
            template: '<input id="single-uploader-input" type="file" class="upload mashup-file-input" nv-file-select uploader="uploader" filters="fileSize, fileType" style="display:none" />',
            scope: {
                errors: '=',
                batch: '=',
                file: '=',
                contributor: '@',
                destination: '=',
                cancelFile: '&',
                updateFileMetadata: '&'
            },
            compile: function() {
                return {
                    pre: function(scope, element, attrs) {
                        scope.uploader = new FileUploader({
                            withCredentials: true,
                            filters: [{
                                name: 'fileSize',
                                fn: function (item) {
                                    return item.size <= UploadLimits.FILE_SIZE;
                                }
                            },
                            {
                                name: 'fileType',
                                fn: function (item) {
                                    var fileExt = item.name.substring(item.name.lastIndexOf('.') + 1);
                                    return UploadLimits.ACCEPTED_FILE_TYPES.indexOf(fileExt.toLowerCase()) > -1;
                                }
                            }]
                        });
                    },
                    post: function(scope, element, attrs) {

                        // After a file is added, create a batch and prepare for uploading the file
                        scope.uploader.onAfterAddingFile = function (fileItem) {
                            if (scope.uploader.queue.length > 1) {
                                scope.uploader.queue.splice(0, 1);
                            }
                            scope.file.name = fileItem.file.name;
                            var lastDotInFilename = scope.file.name.lastIndexOf('.');
                            scope.file.fileNameWithoutExt = scope.file.name.substring(0, lastDotInFilename);
                            var fileExt = scope.file.name.substring(lastDotInFilename + 1);
                            scope.file.needsTranscoding = !(UploadLimits.NO_TRANSCODE_FILE_TYPES.indexOf(fileExt.toLowerCase()) > -1);
                            scope.file.uploadStatus = "File queued for upload... ";
                            scope.file.metadata = {
                                title: scope.file.fileNameWithoutExt,
                                description: "",
                                contributor: scope.contributor,
                                destination: scope.destination
                            };
                            scope.batch.uploader = scope.uploader;
                            scope.file.readyForUpload = true;
                            //scope.$parent.uploadBatch.call();
                        };

                        // Before uploading the file, update its upload status
                        scope.uploader.onBeforeUploadItem = function () {
                            scope.file.uploadStatus = "Uploading File... ";
                            scope.file.uploadStartTime = new Date().getTime();
                        };

                        // update the file's upload progress and upload status
                        scope.uploader.onProgressItem = function (fileItem, progress) {

                            var totalSize = fileItem.file.size,
                                uploadSize = (totalSize / 100) * progress,
                                elapsedTime = new Date().getTime() - scope.file.uploadStartTime,
                                uploadSpeed = uploadSize / (elapsedTime / 1000),
                                remainingTime = (totalSize - uploadSize) / uploadSpeed;

                            if (uploadSpeed !== 0) {
                                scope.file.uploadStatus = "Uploading file... " + Math.floor(remainingTime / 60) + " min " + Math.ceil(remainingTime % 60) + " sec remaining";
                            }

                            if (progress === 100) {
                                scope.file.uploadStatus = "Generating thumbnail... ";
                            }

                        };

                        scope.uploader.onWhenAddingFileFailed = function (item, filter, options) {
                            if (filter.name === 'fileType') {
                                scope.errors.push({
                                    id: Date.now(),
                                    msg: UploadErrors.UPLOAD_FILE_TYPE.formatMessage({name: item.name})
                                });
                            } else if (filter.name === 'fileSize') {
                                scope.errors.push({
                                    id: Date.now(),
                                    msg: UploadErrors.UPLOAD_FILE_SIZE.formatMessage({name: item.name})
                                });
                            }
                        };

                        scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
                            scope.errors.push({id: Date.now(), msg: UploadErrors.UPLOAD_FILE.formatMessage({name: scope.file.name})});
                            // Cancel & Remove the file from the file list since this is a fatal error
                            scope.cancelFile();
                        };

                        // When file upload is successful, create a basefile entry & then a job for the file
                        scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {

                            scope.file.fileId = response.id;
                            var addBaseFileRequest = {};
                            addBaseFileRequest.batchId = scope.batch.batchId;
                            addBaseFileRequest.collectionId = scope.file.metadata.destination.cid;
                            addBaseFileRequest.fileName = scope.file.fileNameWithoutExt;
                            addBaseFileRequest.autoPublish = true;
                            addBaseFileRequest.fileId = response.id;
                            addBaseFileRequest.sendForCaptioning = scope.file.sendForCaptioning;
                            if (response.thumbnails) {
                                addBaseFileRequest.thumbnailId = response.thumbnails[0].id;
                                scope.file.thumbnails = response.thumbnails;
                                scope.file.selectedThumbnail = response.thumbnails[0];
                            } else {
                                scope.file.selectedThumbnail = {id: '000', url: 'assets/images/noThumbnail.jpg'};
                                scope.file.thumbnails = [scope.file.selectedThumbnail];
                            }
                            var baseFileResource = new BaseFileService.AddBaseFile(addBaseFileRequest);
                            baseFileResource.$save(function (baseFile) {
                                scope.file.mediacloudFileId = baseFile.id;
                                scope.updateFileMetadata();
                                scope.file.uploadComplete = true;
                                scope.file.uploadStatus = "File upload complete";

                                var createJobRequest = {};
                                createJobRequest.batchId = scope.batch.batchId;
                                createJobRequest.fileId = response.id;
                                createJobRequest.transcodeFile = true;

                                // Create a job for the file
                                JobService.CreateJob().getNewJob(createJobRequest)
                                    .then(function (job) {
                                        if (job) {
                                            scope.file.jobId = job.jobId;
                                        }
                                    }, function () {
                                        scope.errors.push({
                                            id: Date.now(),
                                            msg: UploadErrors.CREATE_JOB.formatMessage({name: scope.file.name})
                                        });
                                        // Cancel & Remove the file from the file list since this is a fatal error
                                        scope.cancelFile();
                                    });
                            }, function () {
                                scope.errors.push({
                                    id: Date.now(),
                                    msg: UploadErrors.CREATE_BASEFILE.formatMessage({name: scope.file.name})
                                });
                                // Remove the file from the file list since this is a fatal error
                                scope.cancelFile();
                            });
                        };
                    }
                };
            }
        }
    }]);
